import { IObjectionCancellation } from 'us.collection.case/reducers/Dashboard/Interfaces';

export const ObjectionCancellation: IObjectionCancellation = {
	error: false,
	isLoading: false,
};
